import apiIcon from '../../assets/MiniCard/icon-api.svg';
import businessIcon from '../../assets/MiniCard/icon-business.svg';
import reportIcon from '../../assets/MiniCard/icon-report.svg';
import supportIcon from '../../assets/MiniCard/icon-support.svg';
import waChatbotIcon from '../../assets/MiniCard/icon-wa-chatbot.svg';
import waIcon from '../../assets/MiniCard/icon-wa.svg';
import MiniCardWithCta from '../CardWithCta';

const DefaultWhatsAppCTA = () => {
  return (
    <>
      <div className="wa-title">
        <h5>Explore Popular elfoA2P Dashboard Solutions</h5>
      </div>
      <div className="mini-card-wrapper">
        <MiniCardWithCta
          type={2}
          iconSrc={waChatbotIcon}
          title="WhatsApp Chatbot Automation"
          description="Supercharge sales and marketing with WhatsApp chatbot automation, personalized messaging, and efficient customer engagement."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={waIcon}
          title="WhatsApp Broadcasting"
          description="Send transactional updates, OTPs, and WhatsApp marketing messages at scale."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={businessIcon}
          title="Business Account Setup"
          description="Streamline WhatsApp Business account setup and management for efficient customer engagement and seamless communication."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={apiIcon}
          title="API & Integration"
          description="Integrate your CRMs, E-commerce platforms, and more with your WhatsApp inbox via API for seamless connectivity."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={reportIcon}
          title="Reporting & Analytics"
          description="Get actionable insights with detailed reports on customer support performance, including response times, busy hours, message sources, and more."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={supportIcon}
          title="Dedicated Support"
          description="Expert business consultants and technical support teams ensure your digital customer experiences deliver ongoing value and success."
        />
      </div>
    </>
  );
};

export default DefaultWhatsAppCTA;
